import { render, staticRenderFns } from "./NewRealEstateAllList.vue?vue&type=template&id=2e9cdf6b&scoped=true&"
import script from "./NewRealEstateAllList.vue?vue&type=script&lang=js&"
export * from "./NewRealEstateAllList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e9cdf6b",
  null
  
)

export default component.exports